import React, { useEffect, useState, useCallback } from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Titulo from '../../Titulo';
import { IUltimoArquivoDashboard } from '../../../types/dashboard';
import { useLogin } from '../../../contexts/LoginContext';
import { apiServer } from '../../../api';
import { formatarDataComMesExtenso } from '../../../common/utils/formatadorDataHora';
import { DetalhesArquivo } from '../../CentralBackups/components/DetalhesArquivo';

export default function UltimoArquivo() {
    const [login] = useLogin();
    const [ultimoArquivo, setUltimoArquivo] = useState<IUltimoArquivoDashboard>();
    const [modalAberto, setModalAberto] = useState(false);

    const carregarDados = useCallback(() => {
        const clienteID = login.usuario?.usuarioCliente?.clienteID;
        if (!clienteID || !login.accessToken)
            return;

        apiServer<IUltimoArquivoDashboard>()
            .get(`/dashboard/ultimo-arquivo/${clienteID}`, login.accessToken)
            .then((response) => {
                setUltimoArquivo(response.data);
            })
            .catch(() => {});
    }, [login.accessToken, login.usuario?.usuarioCliente?.clienteID]);

    useEffect(() => {
        carregarDados();
    }, [carregarDados]);

    return (
        <>
            <Titulo>Último Backup</Titulo>
            <Typography component="p" variant="h4">
                {`${ultimoArquivo?.tamanho ? ultimoArquivo?.tamanho : 0} GB`}
            </Typography>
            <Typography color="text.secondary" sx={{ flex: 1 }}>
                {formatarDataComMesExtenso(ultimoArquivo?.data)}
            </Typography>
            <div>
                <Link 
                    color="primary" 
                    component="button"
                    variant="body2"
                    onClick={() => setModalAberto(true)}
                    disabled={!ultimoArquivo?.id}
                >
                    Detalhes
                </Link>
            </div>

            <DetalhesArquivo
                arquivoID={ultimoArquivo?.id ? String(ultimoArquivo.id) : null}
                open={modalAberto}
                onClose={() => setModalAberto(false)}
                token={login.accessToken}
            />
        </>
    );
}